module.exports = __webpack_public_path__ + "static/media/deployment_support.d2b84ee1.svg";